import { JSX, useState } from 'react';
import Menu from '../home-page/menu/menu';
import './previewPage.css';
import Clock from '../home-page/clock/clock';
import Weather from '../home-page/weather/weather';
import TodoPreview from '../home-page/preview/todoPreview';

const PreviewPage = () : JSX.Element => {
    const [isTodoPreviewLoading, setIsTodoPreviewLoading] = useState(true);
    const [isNotePreviewLoading, setIsNotePreviewLoading] = useState(true);
    return (
        <div className='preview-page-container'>
            <div className='preview-menu-container'>
                <Menu clickButton={null} onClickButtonChange={null}/>
            </div>
            <div className='previews-container'>
                <div className='preview-clockAndWeather'>
                    <div className='preview-bmo-face'>
                        <Weather/>
                    </div>
                    <div className='preview-clock-container'>
                        <Clock smallerSize={true}/>
                        <div className='clock-margin'>
                            <Clock timeZone='America/Los_Angeles' smallerSize={true}/>
                        </div>
                    </div>
                </div>
                <div className='previewpage-todo-preview'>
                    <TodoPreview setLoading={(loading: boolean) => setIsTodoPreviewLoading(loading)}/>
                </div>
            </div>
        </div>
    );
}

export default PreviewPage;